import StyledForm from '../../../styles/StyledForm';
import StyledFormItem from '../../../styles/StyledFormItem';
import Text from '../../shared/Text/Text';
import Input from '../../shared/Input/Input';
import React, { useEffect, useState } from 'react';
import TelephoneInput from '../../shared/TelephoneInput/TelephoneInput';
import { Skeleton } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';

interface UseFormProps {
  isLoading: boolean;
}

const UserForm: React.FC<UseFormProps> = ({ isLoading }) => {
  const { t } = useTranslation();
  const [isLoadingData, setIsLoadingData] = useState(isLoading);

  useEffect(() => {
    setIsLoadingData(isLoading);
  }, [isLoading]);

  if (isLoading) {
    return (
      <StyledForm margin="0" marginTop="0">
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
        <StyledFormItem>
          <Skeleton width="100px" />
          <Skeleton />
        </StyledFormItem>
      </StyledForm>
    );
  }

  return (
    <StyledForm margin="0" marginTop="0">
      <StyledFormItem>
        <Text type="label">{t('Name')}</Text>
        <Input name="user_name" />
      </StyledFormItem>
      <StyledFormItem>
        <Text type="label">{t('Email')}</Text>
        <Input name="user_email" disabled />
        <small className="info-text">
          {t('Contact Support to update the email address')}
        </small>
      </StyledFormItem>
      <TelephoneInput name="user_phone" />
      <StyledFormItem>
        <Text type="label">{t('Your Role in the Company')}</Text>
        <Input name="user_role" />
      </StyledFormItem>
    </StyledForm>
  );
};

export default UserForm;
